import "antd/dist/antd.css";
import React, { useEffect, useState, useRef, useContext } from "react";

import FlowBuilder, {
  NodeContext,
  BuilderContext,
  buildFlatNodes,
  buildTreeNodes,
  useAction,
} from "react-flow-builder";

const PlaceHolder = () => {
  const StartNodeDisplay = () => {
    const node = useContext(NodeContext);
    return (
      <div class="ph-row" style={{ justifyContent: "center" }}>
        <div style={{ height: 50, width: 50, borderRadius: "50%" }}></div>
      </div>
    );
  };

  const EndNodeDisplay = () => {
    const node = useContext(NodeContext);
    return (
      <div class="ph-row" style={{ justifyContent: "center" }}>
        <div style={{ height: 50, width: 50, borderRadius: "50%" }}></div>
      </div>
    );
  };

  const NodeDisplay = () => {
    const node = useContext(NodeContext);
    return (
      <div class="ph-row" style={{ justifyContent: "center" }}>
        <div style={{ height: 100, width: 300, borderRadius: 5 }}></div>
      </div>
    );
  };

  const ConditionNodeDisplay = () => {
    const node = useContext(NodeContext);
    return (
      <div
        style={{backgroundColor: "#ced4da", width:150, height:50, borderRadius: 5}}
      >
      </div>
    );
  };

  const defaultNodes = [
    {
      id: "node-0d9d4733-e48c-41fd-a41f-d93cc4718d97",
      type: "start",
      name: "start",
      path: ["0"],
    },
  

    {
      id : 'node-b2ffe834-c7c2-4f29-a370-305adc03c010' , 
      type : 'branch' , 
      name : 'branch node' , 
      children : [ 
        {
          id : 'node-cf9c8f7e-26dd-446c-b3fa-b2406fc7821a' , 
          type : 'condition' , 
          name : 'Condition Node' , 
          children : [ 
            {
              id : 'node-f227cd08-a503-48b7-babf-b4047fc9dfa5' , 
              type : 'node' , 
              name : 'Common Node' , 
              path : [ '1' , 'children' , '0' , 'children' , '0' ] ,     
            } ,

            {
              id: "node-972401ca-c4db-4268-8780-5607876d8372",
              type: "node",
              name: "Common Node",
              path: ["2"],
            },
        
            {
              id: "node-972401ca-c4db-4268-8780-5607876d8373",
              type: "node",
              name: "Common Node",
              path: ["2"],
            },
          ] ,
          path : [ '1' , 'children' , '0' ] ,   
        } ,
        {
          id : 'node-9d393627-24c0-469f-818a-319d9a678707' , 
          type : 'condition' , 
          name : 'Condition Node' , 
          children : [ 
            {
              id: "node-972401ca-c4db-4268-8780-5607876d8373",
              type: "node",
              name: "Common Node",
              path: ["2"],
            },
          ] , 
          path : [ '1' , 'children' , '1' ] ,   
        } ,
      ] ,
      path : [ '1' ] , 
    } ,

   
    {
      id: "node-b106675a-5148-4a2e-aa86-8e06abd692d7",
      type: "end",
      name: "end",
      path: ["3"],
    },
  ];

  const registerNodes = [
    {
      type: "start",
      name: "start node",
      displayComponent: StartNodeDisplay,
      isStart: true,
    },
    {
      type: "end",
      name: "end node",
      displayComponent: EndNodeDisplay,
      isEnd: true,
    },
    {
      type: "condition",
      name: "Condition Node",
      displayComponent: ConditionNodeDisplay,
    },
    {
      type: "branch",
      name: "branch node",
      conditionNodeType: "condition",
    },
    {
      type: "node",
      name: "Common Node",
      displayComponent: NodeDisplay,
    },
  ];

  return (
    <React.Fragment>
      <div className="fw-screen">
        <div className="chat-col-skill">
          <div
            class="ph-item"
            style={{ backgroundColor: "#F2F5F6", border: "none" }}
          >
            <FlowBuilder
              className={`outer-drag scrollable flow-builder-for-loop`}
              nodes={defaultNodes}
              registerNodes={registerNodes}
              readonly={true}
              backgroundColor={"#F2F5F6"}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default PlaceHolder;
